export const MUSEUM_WIDTH = 160;

export const CHECKOUT_DIRECT_STATUS_CODE = {
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  INSUFFICIENT_STOCK: 'INSUFFICIENT_STOCK',
};
